/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Grid } from '@coursera/cds-core';

import { CoachButton } from 'bundles/ai-course-coach/components/common';

type Props = {
  message: string;
  onClick: (message: string) => void;
};

const styles = {
  container: css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

const QuickMessage = ({ message, onClick }: Props) => {
  return (
    <Grid container css={styles.container}>
      <Grid item xs={11}>
        <CoachButton variant="secondary" size="medium" fullWidth={false} onClick={() => onClick(message)}>
          {message}
        </CoachButton>
      </Grid>
    </Grid>
  );
};

export default QuickMessage;
